var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "video-player" },
    [
      _c(
        "vue-plyr",
        { ref: "plyr", on: { timeupdate: _vm.videoTimeUpdated } },
        [
          _c("div", {
            attrs: {
              "data-plyr-provider": "vimeo",
              "data-plyr-embed-id": _vm.source
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }